import React, { createContext, useState, useContext, ReactNode } from 'react';


const FooterVisibleStateContext = createContext<boolean | null>(null);
const FooterVisibleDispatchContext = createContext<React.Dispatch<React.SetStateAction<boolean | null>>>(() => {});

export const GlobalStateProvider = ({ children }: { children: ReactNode }) => {
  const [footerIsVisible, setFooterIsVisible] = useState<boolean | null>(null);

  return (
    <FooterVisibleStateContext.Provider value={footerIsVisible}>
      <FooterVisibleDispatchContext.Provider value={setFooterIsVisible}>
        {children}
      </FooterVisibleDispatchContext.Provider>
    </FooterVisibleStateContext.Provider>
  );
};

export const useFooterVisible = () => useContext(FooterVisibleStateContext);
export const useSetFooterVisible = () => useContext(FooterVisibleDispatchContext);